import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { BaseCartLine_Fragment } from "./base-cart-line";

export const BaseCartLineConnectionMasked_Fragment = graphqlShopifyStorefront(
  `
  fragment BaseCartLineConnectionMasked on BaseCartLineConnection {
    edges {
      node {
        __typename
        ...BaseCartLine
        ...BaseCartLine_BaseCartLine
      }
    }
  }
`,
  // [BaseCartLine_Fragment],
);
